<script>
import { dispatch, sync } from 'vuex-pathify';
import FieldComponent from '@/modules/document/_component/fields/FieldComponent.vue';

export default {
    components: {
        FieldComponent,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    computed: {
        width() {
            return this.field.options?.width ?? 12;
        },
        ...sync('document', [
            'view',
        ]),
    },
    methods: {
        showEditFieldModal() {
            dispatch('document/setField', this.field);
            dispatch('document/setShowFieldModal', true);
        },
        showDeleteFieldModal() {
            dispatch('document/setField', this.field);
            dispatch('document/setShowDeleteFieldModal', true);
        },
    },
};
</script>

<template>
    <div
        class="mb-3"
        :class="`col-${width}`"
    >
        <div class="field">
            <div
                class="d-flex align-items-center"
                :class="view === 'preview' ? '' : 'justify-content-between'"
            >
                <div
                    v-if="field.label || view !== 'preview'"
                    class="font-weight-bold mr-5"
                    :style="view === 'preview' ? 'width: 10rem;' : ''"
                >
                    {{ field.label || `Field ${field.id}` }}
                </div>
                <FieldComponent
                    v-if="view === 'preview'"
                    :field="field"
                >
                    Value here
                </FieldComponent>
                <div
                    v-else
                    class="ml-auto text-muted small text-uppercase"
                >
                    {{ field.type || 'text' }}
                </div>
                <div
                    v-if="view === 'edit'"
                    class="ml-3"
                >
                    <b-button
                        type="button"
                        size="xs"
                        @click="showEditFieldModal"
                    >
                        <i class="fa fa-fw fa-pencil" /><span class="sr-only">Edit field</span>
                    </b-button>
                    <b-button
                        type="button"
                        size="xs"
                        variant="outline-danger"
                        @click="showDeleteFieldModal"
                    >
                        <i class="fa fa-fw fa-trash" /><span class="sr-only">Delete field</span>
                    </b-button>
                </div>
            </div>
            <FieldComponent
                v-if="view === 'view'"
                class="mt-3"
                :field="field"
            />
        </div>
    </div>
</template>

<style scoped>
.field {
    padding: 1rem;
    background: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
}
</style>
